import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpeed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 15,
	viewBox: "0 0 20 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.0006 0C11.7557 0.000149931 13.4805 0.462245 15.0004 1.33979C16.5203 2.21747 17.7829 3.47983 18.6604 4.99982C19.538 6.51989 20.0003 8.24445 20.0002 9.99963C20.0002 11.7549 19.5371 13.4794 18.6595 14.9995H1.34175C0.464007 13.4793 6.68864e-05 11.755 1.05657e-09 9.99963C-2.55446e-05 8.24437 0.463178 6.51994 1.34077 4.99982C2.21835 3.4798 3.48082 2.21744 5.00079 1.33979C6.52076 0.462301 8.24553 6.42551e-05 10.0006 0ZM6.70776 5.29278C6.31744 4.90245 5.68431 4.90282 5.29375 5.29278C4.90324 5.68329 4.90324 6.31628 5.29375 6.70679L9.2936 10.7066C9.68414 11.0969 10.3172 11.0971 10.7076 10.7066C11.0975 10.3162 11.0977 9.68298 10.7076 9.29263L6.70776 5.29278Z",
		fill: "#737373"
	})
});
export default SvgSpeed;
